// frontend/src/site/pages/SiteHomeRouter.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useSite } from '../SiteContext';

// modelos antigos (engine atual)
import SiteHomeImobiliaria from '../models/imobiliaria/SiteHomeImobiliaria';
import SiteHomeCorretor from '../models/corretor/SiteHomeCorretor';

// ✅ Lovable (template)
import { TemplateCorretorLovableOrchestrator } from '../templates/TemplateCorretorLovable/orchestrator';

// 🔍 Algolia
import {
  searchProperties,
  buildMicrositeAlgoliaParamsFromSearch,
} from '@/services/searchClient';

export default function SiteHomeRouter() {
  const { handle } = useParams(); // /u/:handle
  const { search } = useLocation();

  const { perfilSite, theme, estrutura, conteudo, ownerWhatsUrl } = useSite();

  const [properties, setProperties] = useState([]);
  const [loadingProps, setLoadingProps] = useState(true);

  /* ==========================================================
     MODEL SELECTION
  ========================================================== */

  const modelId = useMemo(() => {
    return String(perfilSite?.siteConfig?.modelId || '')
      .trim()
      .toLowerCase();
  }, [perfilSite?.siteConfig?.modelId]);

  const siteTemplate = useMemo(() => {
    return String(perfilSite?.siteTemplate || '')
      .trim()
      .toLowerCase();
  }, [perfilSite?.siteTemplate]);

  const isLovable = siteTemplate === 'lovable' || modelId === 'lovable';

  /* ==========================================================
     ALGOLIA — BUSCA IMÓVEIS (9 na home)
  ========================================================== */

  const micrositeParams = useMemo(() => {
    return buildMicrositeAlgoliaParamsFromSearch(search);
  }, [search]);

  useEffect(() => {
    let alive = true;

    async function loadProperties() {
      if (!isLovable) return;
      if (!handle) return;

      try {
        setLoadingProps(true);

        const res = await searchProperties({
          handle,
          queryText: micrositeParams.queryText || '',
          page: 0,
          hitsPerPage: 9, // 🔥 9 na HOME
          params: {
            ...(micrositeParams.params || {}),
          },
        });

        if (!alive) return;

        setProperties(res?.items || []);
      } catch (err) {
        console.warn('[SiteHomeRouter] erro imóveis:', err?.message || err);
        if (!alive) return;
        setProperties([]);
      } finally {
        alive && setLoadingProps(false);
      }
    }

    loadProperties();

    return () => {
      alive = false;
    };
  }, [handle, micrositeParams, isLovable]);

  /* ==========================================================
     RENDER LOVABLE
  ========================================================== */

  if (isLovable) {
    const ctx = {
      theme,
      estrutura,
      conteudo,
      perfilSite,
      ownerWhatsUrl,
      handle: handle || '',
      properties,
      loadingProps,
    };

    return TemplateCorretorLovableOrchestrator.render({
      ctx,
      slug: handle || '',
    });
  }

  /* ==========================================================
     MODELOS ANTIGOS (engine atual)
  ========================================================== */

  if (!modelId || modelId === 'imobiliaria') {
    return <SiteHomeImobiliaria />;
  }

  if (modelId === 'corretor') {
    return <SiteHomeCorretor />;
  }

  return <SiteHomeImobiliaria />;
}
